export default __webpack_public_path__ + "static/img/29.7bda86e.png";